import LogoAsset from '../assets/images/oldlogo.png';


// Application constants
export const API_ENDPOINTS = {
  BASE_URL: process.env.REACT_APP_API_URL || 'https://api.lechalo.com',
  AUTH: {
    LOGIN: '/auth/login',
    REGISTER: '/auth/register',
    LOGOUT: '/auth/logout',
  },
  USER: {
    PROFILE: '/user/profile',
    UPDATE: '/user/update',
  },
} as const;

export const ROUTES = {
  HOME: '/',
  LOGIN: '/login',
  REGISTER: '/register',
  DASHBOARD: '/dashboard',
  PROFILE: '/profile',
  TRIPS: '/trips',
} as const;

export const STORAGE_KEYS = {
  AUTH_TOKEN: 'auth_token',
  USER_DATA: 'user_data',
  THEME: 'theme',
  APP_PROMPT_DISMISSED: 'app_prompt_dismissed',
} as const;

export const APP_CONFIG = {
  IOS_APP_STORE_URL: 'https://apps.apple.com/app/lechalo',
  ANDROID_PLAY_STORE_URL: 'https://play.google.com/store/apps/details?id=com.leChalo',
  DEEP_LINK_SCHEME: 'lechalo://', // Update this with your actual app deep link scheme
  APP_NAME: 'LeChalo',
  // Show prompt again after this many hours (set to 0 to show every time, null to show only once)
  PROMPT_COOLDOWN_HOURS: 10 as number | null, // Change to 0 to show every visit, or null to show only once
};

// Add more constants as needed

export const ASSET_PATHS = {
  LOGO: LogoAsset,
} as const;
